/**
 * BotSetup - Pantalla de configuración de partida contra la IA
 * 501 Dart League Web
 * 
 * Permite configurar:
 * - Nivel de dificultad del bot (1-8)
 * - Modo de juego (301, 501, 701)
 * - Legs para ganar (1-7)
 */

import React, { useState } from 'react';
import { BOT_LEVELS, getBotName } from './utils/botEngine';
import './styles/index.css';
import './styles/x01game.css';

const BotSetup = ({ onBack, onStartGame, user }) => {
  const username = user?.username || 'Jugador 1';
  const [botLevel, setBotLevel] = useState(3);
  const [gameMode, setGameMode] = useState(501);
  const [legsToWin, setLegsToWin] = useState(3);

  const currentBot = BOT_LEVELS[botLevel];

  const handleStart = () => {
    onStartGame({
      playerCount: 2,
      gameMode,
      legsToWin,
      player1Name: username,
      player2Name: getBotName(botLevel),
      botLevel,
    });
  };

  return (
    <div className="dart-league-dashboard training-menu-container">
      <header className="training-menu-header">
        <div className="training-header-top">
          <button className="training-back-btn" onClick={onBack}>
            ← Volver
          </button>
        </div>
        <div className="training-header-icon">
          <img src="/Logo26.png" alt="501 Dart League" className="training-header-logo" />
        </div>
        <h1 className="training-menu-title">Vs IA</h1>
        <p className="training-menu-subtitle">Elige nivel y demuestra tu habilidad</p>
      </header>

      <main className="x01-setup-form">
        {/* Tu nombre (solo lectura) */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Tú</label>
          <input
            type="text"
            className="x01-setup-input x01-setup-input-readonly"
            value={username}
            readOnly
            disabled
          />
        </div>

        {/* Selección de nivel */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Nivel del Bot</label>
          <div className="bot-level-grid">
            {Object.entries(BOT_LEVELS).map(([lvl, profile]) => {
              const level = parseInt(lvl, 10);
              return (
                <button
                  key={level}
                  className={`bot-level-card ${botLevel === level ? 'active' : ''}`}
                  onClick={() => setBotLevel(level)}
                >
                  <span className="bot-level-emoji">{profile.emoji}</span>
                  <span className="bot-level-name">{profile.name}</span>
                  <span className="bot-level-avg">~{profile.targetAvg} avg</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Descripción del nivel seleccionado */}
        <div className="bot-level-description">
          <span className="bot-level-desc-emoji">{currentBot.emoji}</span>
          <div className="bot-level-desc-text">
            <strong>{currentBot.name}</strong>
            <p>{currentBot.description}</p>
            <div className="bot-level-stats">
              <span>AVG: ~{currentBot.targetAvg}</span>
              <span>Checkout: {Math.round(currentBot.checkoutRate * 100)}%</span>
              {currentBot.chance180 > 0 && <span>180s: {(currentBot.chance180 * 100).toFixed(1)}%</span>}
            </div>
          </div>
        </div>

        {/* Modo de juego */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Modo de juego</label>
          <div className="x01-setup-toggle-group three">
            {[301, 501, 701].map(mode => (
              <button
                key={mode}
                className={`x01-toggle-btn ${gameMode === mode ? 'active' : ''}`}
                onClick={() => setGameMode(mode)}
              >
                {mode}
              </button>
            ))}
          </div>
        </div>

        {/* Legs para ganar */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Legs para ganar</label>
          <div className="x01-setup-toggle-group legs">
            {[1, 2, 3, 4, 5, 6, 7].map(n => (
              <button
                key={n}
                className={`x01-toggle-btn small ${legsToWin === n ? 'active' : ''}`}
                onClick={() => setLegsToWin(n)}
              >
                {n}
              </button>
            ))}
          </div>
        </div>

        {/* Resumen */}
        <div className="x01-setup-summary">
          <span>{username} vs {getBotName(botLevel)}</span>
          <span>•</span>
          <span>Best of {legsToWin * 2 - 1}</span>
          <span>•</span>
          <span>{gameMode}</span>
        </div>

        {/* Botón de inicio */}
        <button className="x01-start-btn" onClick={handleStart}>
          <span className="x01-start-icon">🤖</span>
          INICIAR PARTIDA
        </button>
      </main>
    </div>
  );
};

export default BotSetup;
